import React from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface NavbarProps {
  onDemoClick?: () => void;
  onHowItWorksClick?: () => void;
}
export function Navbar({
  onDemoClick,
  onHowItWorksClick
}: NavbarProps) {
  return <motion.nav initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} className="w-full py-6 px-4 md:px-8 flex items-center justify-between max-w-7xl mx-auto relative z-50" data-id="element-242">
      {/* Logo */}
      <div className="flex items-center" data-id="element-243">
        <span className="font-script text-3xl text-white relative" data-id="element-244">
          Ihsanly
          <span className="absolute -top-1 -right-3 text-accent-pink text-xl" data-id="element-245">
            *
          </span>
        </span>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden lg:flex items-center space-x-8" data-id="element-246">
        <button onClick={onHowItWorksClick} className="text-cream-400 text-xs font-bold tracking-widest hover:text-white transition-colors uppercase" data-id="element-247">
          How it works
        </button>
      </div>

      {/* Right Actions */}
      <div className="flex items-center" data-id="element-248">
        <button onClick={onDemoClick} className="bg-gradient-to-r from-accent-purple to-accent-pink text-white text-xs font-bold tracking-widest uppercase px-6 py-3 rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300" data-id="element-249">
          Try Free Demo
        </button>
      </div>
    </motion.nav>;
}